import classNames from 'classnames';
import React, { memo } from 'react';
import { Link } from '@components/Link';

type Props = {
  sectionId: string;
  icon?: any;
  text: string;
  className?: string;
  textClassName?: string;
};

const SectionScroll = ({ sectionId, icon, text, className = '', textClassName = '' }: Props) => {
  return (
    <Link
      href={`#${sectionId}`}
      className={classNames(
        'tw:flex tw:items-center tw:gap-2 tw:font-medium tw:text-body tw:transition tw:duration-200 tw:hover:text-body tw:hover:!no-underline tw:hover:opacity-75',
        className
      )}>
      {!!icon && icon} <span className={classNames('tw:text-sm', textClassName)}>{text}</span>
    </Link>
  );
};

export default memo(SectionScroll);
